export enum Languages {
  EN = "en",
  PL = "pl",
  DE = "de",
  ES = "es",
  FR = "fr",
  SV = "sv",
  NB = "nb",
}

export type Language = {
  languageCode: Languages;
  languageName: string;
};

export enum Translations {
  GLOBAL = "global",
}
